module.exports = __webpack_public_path__ + "static/img/yamamoto_03.07decf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yamamoto_03.jpg
// module id = y97v
// module chunks = 0